import { useCallback, useRef, useState } from "react";

import { Popover } from "antd";
import { clsx } from "clsx";

import { RVIcon, RVIconSizeOptions, useClickOutside } from "@regal-voice/ui";

import styles from "./ShortcutsPopover.module.scss";

type ShortcutsPopoverProps = {
    content: JSX.Element;
};

export function ShortcutsPopover({ content }: ShortcutsPopoverProps): JSX.Element {
    const [isPopoverVisible, setIsPopoverVisible] = useState(false);
    const popoverRef = useRef<typeof Popover>(null);

    const handleOpenPopover = useCallback(() => setIsPopoverVisible(true), []);
    const handleClosePopover = useCallback(() => setIsPopoverVisible(false), []);

    useClickOutside([popoverRef], handleClosePopover);

    return (
        <div data-testid="shortcuts-popover">
            <Popover
                placement="topLeft"
                showArrow={false}
                align={{ offset: [0, 8] }}
                ref={popoverRef}
                open={isPopoverVisible}
                content={content}
                overlayClassName={styles.popoverOverlay}
            >
                <RVIcon
                    icon="keyboard"
                    size={RVIconSizeOptions.LARGE_BUTTON}
                    className={clsx(styles.icon, {
                        [styles.active]: isPopoverVisible,
                    })}
                    onClick={handleOpenPopover}
                />
            </Popover>
        </div>
    );
}
